import { useCallback, useState } from 'react';
import { TUseHoverOrTouchReturnType } from './useHoverOrTouch.type';

function useHoverOrTouch(): TUseHoverOrTouchReturnType {
	const [isHoveringOrTouching, setIsHoveringOrTouching] = useState(false);

	const onMouseEnter = useCallback(() => {
		// check if touch event exists in window
		if ('ontouchstart' in window) return;

		setIsHoveringOrTouching(true);
	}, []);

	const onMouseLeave = useCallback(() => {
		// check if touch event exists in window
		if ('ontouchstart' in window) return;
		setIsHoveringOrTouching(false);
	}, []);

	const onTouchStart = useCallback(() => {
		// check if touch event exists in window
		if (!('ontouchstart' in window)) return;

		setIsHoveringOrTouching(true);
	}, []);

	const onTouchEnd = useCallback(() => {
		// check if touch event exists in window
		if (!('ontouchstart' in window)) return;

		setIsHoveringOrTouching(false);
	}, []);

	return {
		isHoveringOrTouching,
		touchOrHoverHandlers: {
			onMouseEnter,
			onMouseLeave,
			onTouchStart,
			onTouchEnd
		}
	};
}

export { useHoverOrTouch };
